<div class="section-divider d-flex align-items-center gap-3 my-3">
  <div class="flex-grow-1 border-top"></div>
  <span class="fw-semibold small text-uppercase text-muted px-1" style="letter-spacing:.08em;">🌐 Netzwerk</span>
  <div class="flex-grow-1 border-top"></div>
</div>

<div *ngIf="unifi === null && !unifiTimedOut" class="row g-2 mb-2">
  <div class="col-6 col-sm-4 col-lg-3 col-xl-2" *ngFor="let _ of [0,1,2,3]">
    <div class="card h-100">
      <div class="card-body p-2 p-sm-3">
        <app-skeleton width="60%" height=".75rem" radius="4px" [darkMode]="darkMode" style="display:block;margin-bottom:8px;"></app-skeleton>
        <app-skeleton width="80%" height="1.4rem" radius="4px" [darkMode]="darkMode" style="display:block;"></app-skeleton>
      </div>
    </div>
  </div>
</div>
<div *ngIf="unifi === null && unifiTimedOut" class="text-muted small text-center py-2">{{ 'KEINE_DATEN' | translate }}</div>

<div *ngIf="unifi !== null">

  <!-- Gruppe 1: WAN + Clients -->
  <div class="row g-2 mb-2">

    <!-- WAN Status -->
    <div class="col-6 col-sm-4 col-lg-3 col-xl-2">
      <div class="card h-100" [class.border-success]="unifi.wanUp" [class.border-danger]="!unifi.wanUp">
        <div class="card-body p-2 p-sm-3">
          <div class="text-muted small text-truncate">{{ 'UNIFI_WAN' | translate }}</div>
          <div class="fw-bold fs-5" [class.text-success]="unifi.wanUp" [class.text-danger]="!unifi.wanUp">
            {{ unifi.wanUp ? '● Online' : '● Offline' }}
          </div>
        </div>
      </div>
    </div>

    <!-- Download -->
    <div class="col-6 col-sm-4 col-lg-3 col-xl-2" *ngIf="unifi.wanRxBps > 0">
      <div class="card h-100">
        <div class="card-body p-2 p-sm-3">
          <div class="text-muted small text-truncate">↓ {{ 'UNIFI_DOWNLOAD' | translate }}</div>
          <div class="fw-bold fs-5 text-truncate text-info">{{ fmtBps(unifi.wanRxBps) }}</div>
        </div>
      </div>
    </div>

    <!-- Upload -->
    <div class="col-6 col-sm-4 col-lg-3 col-xl-2" *ngIf="unifi.wanTxBps > 0">
      <div class="card h-100">
        <div class="card-body p-2 p-sm-3">
          <div class="text-muted small text-truncate">↑ {{ 'UNIFI_UPLOAD' | translate }}</div>
          <div class="fw-bold fs-5 text-truncate text-info">{{ fmtBps(unifi.wanTxBps) }}</div>
        </div>
      </div>
    </div>

    <!-- Clients gesamt -->
    <div class="col-6 col-sm-4 col-lg-3 col-xl-2">
      <div class="card h-100">
        <div class="card-body p-2 p-sm-3">
          <div class="text-muted small text-truncate">{{ 'UNIFI_CLIENTS' | translate }}</div>
          <div class="fw-bold fs-5">{{ unifi.totalClients }}</div>
          <div class="text-muted small">
            📶 {{ unifi.wlanClients }} &nbsp; 🔌 {{ unifi.lanClients }}
          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- Gruppe 2: Geräte -->
  <div class="section-divider d-flex align-items-center gap-3 my-2">
    <div class="flex-grow-1 border-top" style="border-color:var(--bs-border-color-translucent)!important;"></div>
    <span class="small text-muted px-1">{{ 'UNIFI_GERAETE' | translate }}</span>
    <div class="flex-grow-1 border-top" style="border-color:var(--bs-border-color-translucent)!important;"></div>
  </div>

  <div class="row g-2 mb-2">
    <div class="col-12 col-sm-6 col-lg-4 col-xl-3" *ngFor="let dev of unifiDevicesSorted">
      <div class="card h-100" [class.border-success]="dev.online" [class.border-secondary]="!dev.online" [style.opacity]="dev.online ? 1 : 0.5">
        <div class="card-body p-2 p-sm-3">
          <div class="d-flex align-items-start gap-2">
            <span style="width:32px;height:32px;flex-shrink:0;display:flex;align-items:center;justify-content:center;">
              <img [src]="deviceImg(dev.shortname)" style="width:32px;height:32px;object-fit:contain;"
                   onerror="this.style.display='none';this.nextElementSibling.style.display='inline'">
              <span style="display:none;font-size:1.4rem;line-height:1;">{{ deviceIcon(dev.type) }}</span>
            </span>
            <div class="min-w-0 flex-grow-1">
              <div class="fw-semibold small text-truncate">{{ dev.name }}</div>
              <div class="text-muted" style="font-size:.7rem;">{{ deviceLabel(dev.type) }} · {{ dev.model }}</div>
              <div class="text-muted" style="font-size:.7rem;">
                <span [class.text-success]="dev.online" [class.text-secondary]="!dev.online">
                  {{ dev.online ? '● Online' : '○ Offline' }}
                </span>
                <span *ngIf="dev.online"> · {{ fmtUptime(dev.uptime) }}</span>
              </div>
              <div *ngIf="dev.type === 'uap' && dev.numClients >= 0" class="text-muted" style="font-size:.7rem;">
                📶 {{ dev.numClients }} {{ 'UNIFI_CLIENTS' | translate }}
              </div>
              <div class="text-muted" style="font-size:.7rem;">{{ dev.ip }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="unifiDevicesSorted.length === 0" class="col-12">
      <div class="text-muted small text-center py-2">{{ 'KEINE_DATEN' | translate }}</div>
    </div>
  </div>

  <!-- Gruppe 3: Top-Clients -->
  <div *ngIf="unifi.topClients.length > 0">
    <div class="section-divider d-flex align-items-center gap-3 my-2">
      <div class="flex-grow-1 border-top" style="border-color:var(--bs-border-color-translucent)!important;"></div>
      <span class="small text-muted px-1">{{ 'UNIFI_TOP_CLIENTS' | translate }}</span>
      <div class="flex-grow-1 border-top" style="border-color:var(--bs-border-color-translucent)!important;"></div>
    </div>

    <div class="table-responsive">
      <table class="table table-sm table-hover mb-0" style="font-size:.8rem;">
        <thead>
          <tr class="text-muted">
            <th>{{ 'UNIFI_HOSTNAME' | translate }}</th>
            <th class="d-none d-sm-table-cell">IP</th>
            <th>Typ</th>
            <th class="text-end">↓</th>
            <th class="text-end">↑</th>
            <th class="text-end d-none d-md-table-cell">{{ 'UNIFI_GESAMT' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let cl of unifi.topClients">
            <td class="text-truncate" style="max-width:120px;">{{ cl.hostname }}</td>
            <td class="text-muted d-none d-sm-table-cell text-truncate" style="max-width:110px;">{{ cl.ip }}</td>
            <td>
              <span *ngIf="cl.isWifi">
                📶 <span [class]="signalClass(cl.signal)" style="font-size:.75rem;">{{ cl.signal }} dBm</span>
              </span>
              <span *ngIf="!cl.isWifi" class="text-muted">🔌 LAN</span>
            </td>
            <td class="text-end text-info text-nowrap">{{ fmtBps(cl.rxBps) }}</td>
            <td class="text-end text-info text-nowrap">{{ fmtBps(cl.txBps) }}</td>
            <td class="text-end text-muted text-nowrap d-none d-md-table-cell">
              {{ fmtBytes(cl.rxBytes + cl.txBytes) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</div>
